export default __webpack_public_path__ + "static/media/side-image.8452f075.png";